import * as validationLib from "../../lib/validation";
import cn from "../../lib/classnames";
import React from "react";
import styles from "./BoxInput.module.css";
import textStyles from "../../styles/Text.module.css";
import Toggletip from "../Toggletip";
import {isValidInput} from "../../lib/isValidInput";

const strings = {
    enter: "Enter",
};

type Props = React.ComponentProps<"input"> & {
    value: string;
    label: string;
    placeholder?: string;
    toggleText?: string;
    type?: string;
    validationMessage?: string[];
};

function BoxInput(
    {
        onChange,
        value,
        label,
        placeholder = strings.enter,
        toggleText,
        className,
        type,
        validationMessage,
        ...rest
    }: Props,
    ref: React.ForwardedRef<HTMLInputElement>,
) {
    function onChangeInput(e: React.ChangeEvent<HTMLInputElement>) {
        if (isValidInput(e.target.value) && onChange) {
            onChange(e);
        }
    }

    return (
        <>
            <div className={cn(styles.container, className)}>
                <input
                    className={cn(styles.input, toggleText ? styles.paddingRight : undefined)}
                    onChange={onChange ? onChangeInput : undefined}
                    value={value}
                    aria-label={label}
                    ref={ref}
                    placeholder={placeholder}
                    {...rest}
                    type={type ? type : "text"}
                />
                {toggleText ? (
                    <div className={styles.toggletipContainer}>
                        <Toggletip text={toggleText} />
                    </div>
                ) : null}
                {validationMessage && validationMessage.length ? (
                    <div className={cn(textStyles.inputError, styles.validation)}>
                        {validationLib.getDisplayString(validationMessage)}
                    </div>
                ) : null}
            </div>
        </>
    );
}
export default React.forwardRef<HTMLInputElement, Props>(BoxInput);
